import {
  SET_ISSUES_AN_IS_VALID,
  SET_MATCHER_ITEM,
  SET_RESERVATION_TYPES,
  SET_MATCHER_FOR_DISPLAY,
  CLEAR_SELECT_MATCH_FIELD,
  SET_DATE_TIME_FORMAT,
  SET_SELECTED_TZ,
  CLEAR_MATCH_DATA
} from '@/system/store/mutation-types'

import {
  IReservationType,
  IMatcherItem,
  IMatchFieldsStore,
  IIssue
} from '@/features/matchFields/store'

import { MutationTree, Mutation } from 'vuex'

const setReservationTypes: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, { types }: { types: IReservationType[] }) => {
  return Object.assign(state, { types })
}

const setMatcherForDisplay: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, matcherForDisplay: IMatcherItem) => {
  return Object.assign(state, { matcherForDisplay })
}

const setMatcherItem: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, matcherItem: IMatcherItem) => {
  const { column } = matcherItem
  const matcherForDisplay = state.matcherForDisplay.map((matcher) => {
    if (column !== matcher.column) return matcher
    matcher = matcherItem
    return matcher
  })
  return Object.assign(state, { matcherForDisplay })
}

const clearMatchField: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, { value }: any) => {
  const matcherForDisplay = state.matcherForDisplay.map((matcher) => {
    if (matcher.assignedField && matcher.assignedField[value]) {
      matcher.assignedField = null
    }
    return matcher
  })
  return Object.assign(state, { matcherForDisplay })
}

const setIssuesAndIsValid: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, { issues, isValid }: { issues: IIssue[], isValid: boolean }) => {
  return Object.assign(state, { issues, isValid })
}

const setDateTimeFormat: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, dateTimeFormat: string) => {
  state.dateTimeFormat = dateTimeFormat
  return state
}

const setTz: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore, tz: string) => {
  state.selectedTZ = tz
  return state
}

const clearMatchData: Mutation<IMatchFieldsStore> = (state: IMatchFieldsStore) => {
  state.isValid = false
  state.issues = []
  state.matcherForDisplay = []
  state.dateTimeFormat = 'DD-MM-YYYYTHH:mm:ss'
  state.selectedTZ = ''
  return state
}

const mutations: MutationTree<IMatchFieldsStore> = {
  [SET_RESERVATION_TYPES]: setReservationTypes,
  [SET_MATCHER_FOR_DISPLAY]: setMatcherForDisplay,
  [SET_MATCHER_ITEM]: setMatcherItem,
  [CLEAR_SELECT_MATCH_FIELD]: clearMatchField,
  [SET_ISSUES_AN_IS_VALID]: setIssuesAndIsValid,
  [SET_DATE_TIME_FORMAT]: setDateTimeFormat,
  [SET_SELECTED_TZ]: setTz,
  [CLEAR_MATCH_DATA]: clearMatchData
}

export default mutations
